<ng-container *ngIf="state === 'addToCollection'; else createOnly">
  <h1 mat-dialog-title>{{ 'addToCollectionDialog.labels.addToCollection' | translate }}</h1>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <div mat-dialog-content test-id="add-to-collection-dialog">
    <p>{{ 'addToCollectionDialog.labels.addToCollectionInstructions' | translate }}</p>
    <form [formGroup]="form" class="form-full-width">
      <div class="half-width">
        <mat-radio-group test-id="collection-type" (change)="existingOrNewChanged($event)" value="existing">
          <mat-radio-button test-id="collection-type-existing" value="existing">{{ 'addToCollectionDialog.labels.chooseExisting' | translate }}</mat-radio-button>
          <mat-radio-button test-id="collection-type-new" value="new">{{ 'addToCollectionDialog.labels.createNewCollection' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="half-width">
        <mat-form-field appearance="outline">
          <mat-select test-id="collection-select" placeholder="{{ 'addToCollectionDialog.labels.selectCollection' | translate }}" formControlName="selectedCollection">
            <mat-option *ngFor="let collection of existingCollections" [value]="collection._id">{{ collection.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input matInput test-id="new-collection-name" formControlName="newCollectionName"
            placeholder="{{ 'addToCollectionDialog.labels.newCollectionName' | translate }}">
          <mat-error *ngIf="form.get('newCollectionName').errors?.required">{{ 'addToCollectionDialog.errors.nameRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.get('newCollectionName').errors?.unique">{{ 'addToCollectionDialog.errors.nameExists' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <p>{{ 'addToCollectionDialog.labels.addToCollectionNote' | translate }}</p>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-dialog-close mat-stroked-button test-id="close-button">{{ 'common.actions.close' |
      translate
      }}</button>
    <button mat-flat-button test-id="save-button" color="primary" [disabled]="form.invalid" (click)="addToCollection()">
      {{ 'common.actions.save' | translate }}
    </button>
  </div>
</ng-container>

<ng-template #createOnly>
  <h1 mat-dialog-title>{{ 'addToCollectionDialog.labels.createNewCollection' | translate }}</h1>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <div mat-dialog-content test-id="add-to-collection-dialog">
    <mat-form-field appearance="outline" class="full-width">
      <input matInput test-id="create-only-name" [formControl]="newCollectionControl" placeholder="{{ 'addToCollectionDialog.labels.newCollectionName' | translate }}">
      <mat-error *ngIf="newCollectionControl.errors?.required">{{ 'addToCollectionDialog.errors.nameRequired' | translate }}</mat-error>
      <mat-error *ngIf="newCollectionControl.errors?.unique">{{ 'addToCollectionDialog.errors.nameExists' | translate }}</mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-dialog-close mat-stroked-button test-id="close-button">{{ 'common.actions.close' |
      translate
      }}</button>
    <button mat-flat-button test-id="create-button" color="primary" (click)="submitCreateOnly()" [disabled]="newCollectionControl.invalid">
      {{ 'common.actions.create' | translate }}
    </button>
  </div>
</ng-template>
